import React from 'react';
import {Modal, Descriptions} from 'antd';
import ImagePictureCard from '@/components/ImagePictureCard';
import moment from 'moment'
import Common from '../../components/commonTable/commonShowComponent';
import styles from './index.less';

const DemandResult = ({
  onCancel,
  result = {},
  type = 'default'
}) => {
  const modalProps = {
    title: '需求分析',
    footer: null,
    visible: true,
    onCancel,
    className: styles['evaluation-result-modal'],
    width: 800
  };

  return (
    <Modal {...modalProps}>
      {type === 'default'?
      
      <div className='result-summary'>
        {/* <div className='summary-label'>基本信息</div> */}
        <div className='summary-content'>
          <Descriptions column={2}>
            <Descriptions.Item label='来访姓名'>{result.visitorName}</Descriptions.Item>
            <Descriptions.Item label='付费方姓名'>{result.payerName}</Descriptions.Item>
            <Descriptions.Item label='时间日期'>{result.date && moment(result.date).format('YYYY-MM-DD')}</Descriptions.Item>
            <Descriptions.Item label='与来访者关系'>{result.relationshipBetweenPayerAndVisitor}</Descriptions.Item>
          </Descriptions>
        </div>
        <div className='summary-label'>来访者需求</div>
        <div className='summary-content'>
          <Descriptions column={2}>
            <Descriptions.Item label='期望效果'>{result.visitorExpectedTherapeuticEffect}</Descriptions.Item>
            <Descriptions.Item label='特殊要求'>{result.visitorMostWantToSolveTheProblem}</Descriptions.Item>
          </Descriptions>
        </div>
        <div className='summary-label'>决策者需求</div>
        <div className='summary-content'>
          <Descriptions column={2}>
            <Descriptions.Item label='最想解决的问题'>{result.decisionMakerExpectedTherapeuticEffect}</Descriptions.Item>
            <Descriptions.Item label='核心需求'>{result.decisionMakerPaidCoreNeeds}</Descriptions.Item>
          </Descriptions>
        </div>
        <div className='summary-label'>服务设置</div>
        <div className='summary-content'>
          <Descriptions column={2}>
            <Descriptions.Item label='可预约时间'>{result.availableTime && moment(result.availableTime).format('YYYY-MM-DD') }</Descriptions.Item>
            <Descriptions.Item label='承诺咨询时间'>{result.consultantDoctorCommitmentConsultationTime && moment(result.consultantDoctorCommitmentConsultationTime).format('YYYY-MM-DD') }</Descriptions.Item>
          </Descriptions>
        </div>
        <div className='summary-label'>心理顾问承诺其他服务</div>
        <div className='summary-content'>
          <Descriptions column={1}>
            <Descriptions.Item label=''>{result.consultantDoctorCommitmentToOtherServices}</Descriptions.Item>
          </Descriptions>
        </div>
        <div className='summary-label'>客户评级</div>
        <div className='summary-content'>
          <Descriptions column={2}>
            <Descriptions.Item label=''>{result.customerRating}</Descriptions.Item>
            <Descriptions.Item label='支付能力'>{result.abilityToPay}</Descriptions.Item>
            <Descriptions.Item label='评估依据'>{result.evaluationBasis}</Descriptions.Item>
          </Descriptions>
        </div>
        <div className='summary-label'>潜在异议</div>
        <div className='summary-content'>
          <Descriptions column={2}>
            <Descriptions.Item label=''>{result.potentialObjection}</Descriptions.Item>
            <Descriptions.Item label='其他备注'>{result.otherNotes}</Descriptions.Item>
          </Descriptions>
        </div>
      </div>
      :<Common result={result}/>}
    </Modal>
  );
};

export default DemandResult;
